import { render, staticRenderFns } from "./AiAssistant.vue?vue&type=template&id=718e4176&scoped=true&"
import script from "./AiAssistant.vue?vue&type=script&lang=js&"
export * from "./AiAssistant.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistant.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AiAssistant.vue?vue&type=style&index=1&id=718e4176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e4176",
  null
  
)

export default component.exports